import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import swal from 'sweetalert';
import RaisedButton from 'material-ui/RaisedButton';
import Help from '../../generics/help';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';

var Config = require('../../../config');


class StoreUnits extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.changeEquipment = this.changeEquipment.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onCancel = this.onCancel.bind(this);

		this.state = {
			unit: [], 
			unit_number:"",
			code_component:"",
			component_number:"",
			code_component_list:[],
			value:"",
			suggestions:[],
			equipment_id:"",
		    equipment:[],
		    location_id:"",
		    location:{
		    	storage_ubications:[],
		    	type:""
		    }, 
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); 
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			this.validateInput(e);
			this.waiting_modal.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'units/storage_ubication?health_facilities_id='+sessionStorage.getItem("health_facilities_id")+
					'&unit_number='+e.target.value, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					this.setState({
						code_component_list: response
					})
					
				}

			})

		}
	}

	handleChange(event){
		this.setState({[event.target.name] : event.target.value});

		var control = document.getElementById(event.target.name);
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

	}

	onSearch(e){
		if(e.length > 0){
			var component = e[0].label.split(' ')[0];
			var number = e[0].label.split(' ')[1];
			this.setState({
	   			code_component: component,
	   			component_number: number,
	   		});

			if(this.isValidSearch()){
				this.waiting_modal.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+'units/by_code_component?code='+component+"&unit_number="+
						this.state.unit_number+"&component_number="+number+'&process=storage_ubication', {
					method : 'get',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				})
				.then(res => {
					this.waiting_modal.handleClose();
			        if(res.ok){
			          return res.json();
			        }else{
			          res.text().then(function(result) {
			            swal('¡Error!', result, 'error');
			            return;
			          });
			        }})
				.then(response => {
					if(response !== undefined){

						response.units[0].map((u)=>{
							this.getEquipments(u.unit.id);
						})

						document.getElementById('equipment_id').focus();
						
					}
				});
			}else{
				swal('Búsqueda sin resultados', "", 'warning');
			}
		}
	}

	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	getEquipments(unit) {
		this.waiting_modal.handleShow('Cargando...');
		
		fetch(Config.default.apiGateway.URL+'storage_ubication/equipments',{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res =>{
			this.waiting_modal.handleClose();

			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result){
					swal("Error", result, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					equipment:response,
					unit: [unit]
				});
			}
		});

	}

	changeEquipment(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		fetch(Config.default.apiGateway.URL+'storage_ubication/by_equipment?equipment_id='+e.target.value,{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res =>{
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result){
					swal("Error", result, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({location:response});
			}
		});
	}

	onSave(){
		if(this.isValidForm()){
			this.waiting_modal.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+'units/set_storage_ubication?storage_ubication_id='+this.state.location_id,{
				method:'post',
				body: JSON.stringify(this.state.unit),
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res =>{
				this.waiting_modal.handleClose();

				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result){
						swal("Error", result, 'error');
					});
				}
			}).then(response=>{
				if(response !== undefined){
					notify.show("Registro guardado correctamente.", 'success');
					this.setState({
					    unit: [], 
						unit_number:"",
						code_component:"",
						component_number:"",
						code_component_list:[],
						value:"",
						suggestions:[],
						equipment_id:"",
					    equipment:[],
					    location_id:"",
					    location:{
					    	storage_ubications:[],
					    	type:""
					    }, 

					});

					this._typeahead.getInstance().clear();

				}
			});
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}
	}

	onCancel(){
		this.props.history.push('/');
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		if(input.id === 'requested_by' || input.id === 'requested_to'){
	    			isFormValid = this.getValidationState(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}
	    		
			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.warehouse.MAIN')} ->
						{t('sidebar.nav.warehouse.storeUnits')}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_storage"} 
		            submenu={"help_units_set_storage"}  />
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">No de Unidad</span>
								<input className={this.state.unit_number_required ? "form-control error" : "form-control"} type="text" 
									id = "unit_number" name="unit_number" onKeyPress={(e) => this.searchComponent(e)} 
									onChange={this.handleChange} required
									value={this.state.unit_number || ""} />
							</div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">Código componente</span>
								<AsyncTypeahead
						          	/*{...this.state}*/
						          	labelKey={(option) => `${option.label}`}
						          	minLength={0}
						          	options={this.state.code_component_list}
						          	onChange={this.onSearch}	
						            inputProps={{
						          		name:"code_component",
						          		required: "required",
						          		id:"code_component"
						          	}}
						          	id="codeComponent"
						          	useCache={false}
						          	ref={ref => this._typeahead = ref}
						          	isLoading={this.state.isLoading}
						          	delay={600}
						          	paginationText="Mostrar mas resultados..."
						        />
						       

							</div>
						</div>	

						<hr style={{width:"100%"}}/>

						<div className="col-xs-12 form-group">
			        		<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
			        			<span>Equipo:</span>
			        		</div>
			        		<div className="col-xs-12 col-sm-4">
					        	<select name="equipment_id" className="form-control" id="equipment_id" 
					        		onKeyPress={(e) => this.validateInput(e)} required
					        		value={this.state.equipment_id || ""} 
					        		onChange={this.changeEquipment}>
					        		<option value="">Seleccione...</option>
					        		{this.state.equipment.map((e)=>{
					        			return <option key={e.id} value={e.id}>{e.name}</option>
					        		})}
					        	</select>
					        </div>
				        </div>

				        <div className="col-xs-12 form-group">
			        		<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
			        			<span>Ubicación:</span>
			        		</div>
			        		<div className="col-xs-12 col-sm-4">
					        	<select name="location_id" className="form-control" id="location_id" 
					        		onKeyPress={(e) => this.validateInput(e)} required
					        		value={this.state.location_id || ""} onChange={this.handleChange}>
					        		<option value="">Seleccione...</option>
					        		{this.state.location.storage_ubications.map((e)=>{
					        			return this.state.location.type === 'SIMPLE' ?
					        				<option key={e.id} value={e.id}>GENERAL</option>
					        			: <option key={e.id} value={e.id}>
					        				{e.storage_level !== null?
					        					"NIVEL "+e.storage_level.name+" "
					        				:null}
					        				{e.storage_column !== null?
					        					"COLUMNA "+e.storage_column.name+" "
					        				:null}
					        				{e.storage_line !== null?
					        					"LINEA "+e.storage_line.name+" "
					        				:null}
					        			</option>
					        		})}
					        	</select>
					        </div>
				        </div>

				        <hr style={{width:"100%"}}/>
						<div className="col-xs-12" style={{textAlign:'center'}}>
				        	<div>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>
				        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onCancel} style={{margin:12}}/>
				        	</div>
				        </div>
												
					</div>


				</form>

				<Notifications />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(StoreUnits);
